// The default environment represents local development. The contents of this file will be replaced
// during the build/serve process with the specified environment.

const browserLocation = typeof window === 'undefined'
    ? undefined
    : window.location;
const hostname = browserLocation?.hostname ?? 'localhost';

const isLocalHost = hostname.indexOf('localhost') > -1;
const isDevelopment = isLocalHost
    || hostname.indexOf('dev') > -1
    || (hostname.split('.').slice(-2).join('.') === 'spsc.io');

const useProductionMode = !isDevelopment;
const urlSubDomain = isDevelopment
    ? '.dev'
    : '';
const baseUrl = browserLocation
    ? `${browserLocation.protocol}//${browserLocation.host}`
    : '';
const launchDarklyClientId = isDevelopment
    ? '61df0e8e10ca3613630c1dc6'
    : '61df0e8e10ca3613630c1dc7';


export const environment = {
    useProductionMode,
    urlSubDomain,
    baseUrl,
    launchDarklyClientId
};
